import styled from 'styled-components';

export const LabelContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const LabelTitle = styled.label`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
`;
